function applyTabulatorPatch(tabulator) {
  if (!tabulator || tabulator.__samPatched) {
    return;
  }

  // Wrap the constructor so every table gets renderVertical: "basic" and we keep a reference.
  if (!tabulator.__samConstructorPatched && typeof tabulator === "function") {
    const OriginalTabulator = tabulator;

    const WrappedTabulator = function tabulatorWrapper(selector, options) {
      const mergedOptions = {
        ...options,
      };

      if (!mergedOptions.renderVertical) {
        mergedOptions.renderVertical = "basic";
      }

      const table = new OriginalTabulator(selector, mergedOptions);

      // Keep a handle on the DOM element for redraws when tabs are shown.
      let element = selector;
      if (typeof selector === "string") {
        element = document.querySelector(selector);
      }

      if (element) {
        element.__samTabulator = table;
      }

      return table;
    };

    WrappedTabulator.prototype = OriginalTabulator.prototype;
    Object.setPrototypeOf(WrappedTabulator, OriginalTabulator);
    window.Tabulator = WrappedTabulator;
    tabulator = WrappedTabulator;
    tabulator.__samConstructorPatched = true;
  }

  // Set default renderVertical to "basic" to avoid Chrome resize recursion.
  if (tabulator.prototype?.defaultOptions) {
    tabulator.prototype.defaultOptions.renderVertical = "basic";
  }

  // Guard adjustTableSize against recursive re-entry.
  if (!tabulator.__samAdjustSizePatched) {
    const originalAdjust = tabulator.prototype?.adjustTableSize;
    if (typeof originalAdjust === "function") {
      tabulator.prototype.adjustTableSize = function patchedAdjustTableSize() {
        if (this.__samAdjustingSize) {
          return;
        }

        this.__samAdjustingSize = true;

        try {
          return originalAdjust.apply(this, arguments);
        } finally {
          this.__samAdjustingSize = false;
        }
      };
    }
    tabulator.__samAdjustSizePatched = true;
  }

  tabulator.__samPatched = true;
}

function tryPatchTabulator() {
  if (typeof window === "undefined" || !window.Tabulator) {
    return false;
  }

  applyTabulatorPatch(window.Tabulator);
  return true;
}

function redrawTabulatorsIn(targetEl) {
  if (!targetEl) {
    return;
  }

  targetEl.querySelectorAll(".tabulator").forEach((node) => {
    const table = node.__samTabulator;
    if (table && typeof table.redraw === "function") {
      table.redraw(true);
    }
  });
}

function setupTabRedrawObserver() {
  // Handle Flowbite tab clicks (role="tab").
  document.addEventListener("click", (event) => {
    const tabButton = event.target.closest('[role="tab"][data-tabs-target]');
    if (!tabButton) {
      return;
    }

    const targetSelector = tabButton.getAttribute("data-tabs-target");
    if (!targetSelector) {
      return;
    }

    // Wait for Flowbite to toggle visibility, then redraw.
    window.setTimeout(() => {
      const targetEl = document.querySelector(targetSelector);
      redrawTabulatorsIn(targetEl);
    }, 0);
  });
}

// Attempt immediately, then retry a few times until Tabulator loads.
if (!tryPatchTabulator()) {
  const maxAttempts = 20;
  let attempts = 0;
  const intervalId = window.setInterval(() => {
    attempts += 1;
    if (tryPatchTabulator() || attempts >= maxAttempts) {
      window.clearInterval(intervalId);
    }
  }, 50);

  window.addEventListener("DOMContentLoaded", tryPatchTabulator, { once: true });
  window.addEventListener("load", tryPatchTabulator, { once: true });
}

// Always set up tab redraw listener.
if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupTabRedrawObserver, { once: true });
  } else {
    setupTabRedrawObserver();
  }
}
